module.exports = __webpack_public_path__ + "img/stopwatch-fill.e19e43db.svg";